module.exports = __webpack_public_path__ + "img/snow_heavy.4ec83184.svg";